import { useCallback, useEffect, useState } from 'react'

/**
 * Monitor container scroll state, provide left and right scroll indicators
 * @param container - scroll container
 * @returns scroll state and update function
 */
export default function useScrollFade(container: HTMLDivElement | null) {
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const update = useCallback(() => {
    if (!container) return

    const { scrollLeft, scrollWidth, clientWidth } = container
    setCanScrollLeft(scrollLeft > 0)
    const remainingRight = scrollWidth - scrollLeft - clientWidth
    setCanScrollRight(remainingRight > 1)
  }, [container])

  useEffect(() => {
    if (!container) return

    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(container)
    container.addEventListener('scroll', update)
    container.addEventListener('touchmove', update)

    requestAnimationFrame(update)

    return () => {
      container.removeEventListener('scroll', update)
      container.removeEventListener('touchmove', update)
      resizeObserver.disconnect()
    }
  }, [update, container])

  return { canScrollLeft, canScrollRight, updateScrollFade: update }
}
